import { render, staticRenderFns } from "./BasketPage.vue?vue&type=template&id=7713cd7d&scoped=true&"
import script from "./BasketPage.vue?vue&type=script&lang=js&"
export * from "./BasketPage.vue?vue&type=script&lang=js&"
import style0 from "./BasketPage.vue?vue&type=style&index=0&id=7713cd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7713cd7d",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/basket_page.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FBasketPage.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports